import { Questions } from './questions/questions'
import { DynamicTable } from './dynamicTable/dynamicTable'
import { CrossTableEditor } from './crossTable/editor'
import { CrossTableQuestionsOverview } from './crossTable/questionsOverview'
import { TextAnalyticsEditor } from '@/modules/editor/logic/textAnalytics/editor'

export const Logic = (() => {
	const init = () => {
		CrossTableEditor.init()
		CrossTableQuestionsOverview.init()
		Questions.init()
		DynamicTable.init()
		TextAnalyticsEditor.init()
	}

	return {
		init,
	}
})()
